module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "subpage delcare1"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "text-block title-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("标题")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "selects"
  }, [_c('div', {
    staticClass: "select-line"
  }, [_c('div', {
    staticClass: "selectGp"
  }, [_c('span', [_vm._v("政策分类")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "declarationOrPolicyClassificationId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "sbhzcfl",
      "selectId": _vm.params.declarationOrPolicyClassificationId,
      "paramsKey": "declarationOrPolicyClassification",
      "plaText": "政策分类"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', [_vm._v("特定对象")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "specificObjectId"
    }
  }, [_c('all-select', {
    attrs: {
      "code": "tddx",
      "selectId": _vm.params.specificObjectId,
      "paramsKey": "specificObject",
      "plaText": "特定对象"
    },
    on: {
      "selectChange": _vm.allSelect
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', [_vm._v("发布层级")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "releaseLevelId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "fbjb",
      "selectId": _vm.params.releaseLevelId,
      "paramsKey": "releaseLevel",
      "plaText": "发布层级"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "select-line"
  }, [_c('div', {
    staticClass: "selectGp"
  }, [_c('span', [_vm._v("发文机构")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "publishingDepartmentNames"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "如有多个机构，请用 ‘，’ 隔开",
      "size": "medium"
    },
    model: {
      value: (_vm.params.publishingDepartmentNames),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishingDepartmentNames", $$v)
      },
      expression: "params.publishingDepartmentNames"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', [_vm._v("发文字号")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.sendTextNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "sendTextNumber", $$v)
      },
      expression: "params.sendTextNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', [_vm._v("成文日期")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "writtenDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "size": "medium",
      "align": "right",
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.writtenDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "writtenDate", $$v)
      },
      expression: "params.writtenDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "select-line"
  }, [_c('div', {
    staticClass: "selectGp"
  }, [_c('span', [_vm._v("开始日期")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "applicationStartDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "size": "medium",
      "align": "right",
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.applicationStartDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "applicationStartDate", $$v)
      },
      expression: "params.applicationStartDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', [_vm._v("截止日期")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "applicationDeadline"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "size": "medium",
      "align": "right",
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.applicationDeadline),
      callback: function($$v) {
        _vm.$set(_vm.params, "applicationDeadline", $$v)
      },
      expression: "params.applicationDeadline"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', [_vm._v("申报状态")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "declarationStatusId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "sbzt",
      "selectId": _vm.params.declarationStatusId,
      "paramsKey": "declarationStatus",
      "plaText": "申报状态"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block title-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("受理时间")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "prop": "title"
    }
  }, [_c('el-time-picker', {
    attrs: {
      "align": "right",
      "size": "medium",
      "is-range": "",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "format": "HH:mm",
      "value-format": "HH:mm",
      "placeholder": "选择时间"
    },
    on: {
      "change": _vm.pickerChange
    },
    model: {
      value: (_vm.applicationTime),
      callback: function($$v) {
        _vm.applicationTime = $$v
      },
      expression: "applicationTime"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "text-block img-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("封面图")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('img-upload', {
    attrs: {
      "image": _vm.params.image,
      "tips": "（115*70推荐）"
    },
    on: {
      "imgChange": _vm.imgChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "enclosure"
  }, [_c('div', {
    staticClass: "ttl"
  }, [_vm._v("附件")]), _vm._v(" "), _c('div', {
    staticClass: "ecContent"
  }, [_c('file-upload', {
    attrs: {
      "files": _vm.params.fileId
    },
    on: {
      "fileChange": _vm.fileChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block tag-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("标签")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('tag-select', {
    attrs: {
      "selectTags": _vm.params.tagNames,
      "paramsKey": "tagNames"
    },
    on: {
      "selectChange": _vm.tagChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block radio-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("可见范围")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.radioType),
      callback: function($$v) {
        _vm.radioType = $$v
      },
      expression: "radioType"
    }
  }, [_c('el-radio', {
    attrs: {
      "border": "",
      "size": "medium",
      "label": 1
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "size": "medium",
      "label": 2
    }
  }, [_vm._v("指定类型")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "size": "medium",
      "label": 3
    }
  }, [_vm._v("指定企业")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "size": "medium",
      "label": 4
    }
  }, [_vm._v("指定用户")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block check-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [(_vm.radioType == 2) ? _c('div', [_c('el-checkbox-group', {
    model: {
      value: (_vm.idArr1),
      callback: function($$v) {
        _vm.idArr1 = $$v
      },
      expression: "idArr1"
    }
  }, _vm._l((_vm.selectList1), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.radioType == 3) ? _c('div', {
    staticClass: "check-seek"
  }, [_c('div', {
    staticClass: "seek-head"
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.entSeek,
      "loading": _vm.loading1,
      "placeholder": "搜索企业名称"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.entId),
      callback: function($$v) {
        _vm.entId = $$v
      },
      expression: "entId"
    }
  }, _vm._l((_vm.selectList2), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.entSelect
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seek-body"
  }, _vm._l((_vm.idArr2), function(item, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "value": item.id,
        "type": "danger",
        "closable": ""
      },
      on: {
        "close": function($event) {
          _vm.entRemove(index)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(item.name) + "\n                            ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.radioType == 4) ? _c('div', {
    staticClass: "check-seek"
  }, [_c('div', {
    staticClass: "seek-head"
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.userSeek,
      "loading": _vm.loading2,
      "placeholder": "搜索用户"
    },
    model: {
      value: (_vm.userId),
      callback: function($$v) {
        _vm.userId = $$v
      },
      expression: "userId"
    }
  }, _vm._l((_vm.selectList3), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.name,
        "value": item.userId
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v("（" + _vm._s(item.enterpriseName) + "）")])])
  })), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.userSelect
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seek-body"
  }, _vm._l((_vm.idArr3), function(item, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "danger",
        "closable": ""
      },
      on: {
        "close": function($event) {
          _vm.userRemove(index)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(item.name) + "（" + _vm._s(item.enterpriseName) + "）\n                            ")])
  }))]) : _vm._e()])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-39f7afc1"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/declare/src/Subpage1.vue
// module id = 1455
// module chunks = 1